// --- end new updated ------
// eslint-disable-next-line no-restricted-syntax
var ScreenSizes;
(function (ScreenSizes) {
    ScreenSizes["Default"] = "Default";
    ScreenSizes["XXL"] = "XXL";
    ScreenSizes["XL"] = "XL";
    ScreenSizes["LG"] = "LG";
    ScreenSizes["MD"] = "MD";
    ScreenSizes["SM"] = "SM";
    ScreenSizes["XS"] = "XS";
    ScreenSizes["XXS"] = "XXS";
})(ScreenSizes || (ScreenSizes = {}));
// ------ end old --------

export { ScreenSizes };
